module.exports = __webpack_public_path__ + "d9e5fb40dacd3719af7ce0c7bf41449f.svg";